import { FIREBALL_ORBIT_RADIUS, FIREBALL_ORBIT_STEP, FIREBALL_COUNT } from '@shared/constants.js';

export interface FireballPos {
  x: number;
  y: number;
}

/** Compute fireball orbit positions for a player at (px, py) on the given tick. */
export function getFireballPositions(px: number, py: number, tick: number): FireballPos[] {
  const positions: FireballPos[] = [];
  for (let i = 0; i < FIREBALL_COUNT; i++) {
    const angle = (Math.PI * 2 * i) / FIREBALL_COUNT + tick * FIREBALL_ORBIT_STEP;
    positions.push({
      x: Math.round(px + Math.cos(angle) * FIREBALL_ORBIT_RADIUS),
      y: Math.round(py + Math.sin(angle) * FIREBALL_ORBIT_RADIUS),
    });
  }
  return positions;
}
